import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const BarChartComponent = ({ data, title, aspect ,barType="horizontal" }) => {
  // let data = [
  //   {
  //     "count": 105,
  //     "month": 1,
  //     "year": 2023
  //   },
  //   {
  //     "count": 105,
  //     "month": 2,
  //     "year": 2023
  //   },
  //   {
  //     "count": 105,
  //     "month": 3,
  //     "year": 2023
  //   },
  //   {
  //     "count": 58,
  //     "month": 8,
  //     "year": 2023
  //   },
  //   {
  //     "count": 58,
  //     "month": 11,
  //     "year": 2023
  //   },
  //   {
  //     "count": 164,
  //     "month": 9,
  //     "year": 2023
  //   },
  //   {
  //     "count": 3,
  //     "month": 7,
  //     "year": 2023
  //   },
  //   {
  //     "count": 105,
  //     "month": 10,
  //     "year": 2023
  //   },
  
  // ]
  const truncateLabel = (label, maxLength = 200) => {
    if (label.length > maxLength) {
      return `${label.substring(0, maxLength)}...`;
    }
    return label;
  };
  return (
    <div className="bar-chart" style={{ backgroundColor: "var(--jy-surface-1)", boxShadow: "var(--jy-card-shadow)", borderRadius: "10px" }}>
      <div className="title" style={{ padding: "16px 25px", fontWeight: "bold", fontSize: "14px", color: "var(--jy-text-secondary)" }}>{title}</div>
       
      <ResponsiveContainer aspect={aspect}>
        <BarChart
          data={data}
          margin={{ top: 10, right: 30, left: 0, bottom: 20 }}
          layout={barType}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="var(--jy-border)" />
          {barType === "horizontal" ? <><XAxis dataKey="label" stroke="var(--jy-text-secondary)" tickFormatter={(label)=> truncateLabel(label,10)} />
          <YAxis type="number" stroke="var(--jy-text-secondary)" /></>: <><XAxis type="number" stroke="var(--jy-text-secondary)" /> {/* XAxis for numerical values */}
          <YAxis dataKey="label" type="category" stroke="var(--jy-text-secondary)" width={200} tickFormatter={(label)=> truncateLabel(label,20)} /> {/* YAxis for labels */}</>} 
          <Tooltip 
            formatter={(value) => value.toFixed(0)} // To show the exact count without rounding
          />
          <Bar dataKey="count" fill="#8884d8" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BarChartComponent;
